/**
 * Regenivus storefront behaviour — ported from the design's support.js.
 * Two progressive enhancements, no dependencies:
 *   1. Draggable before/after comparison sliders (.rgv-ba)
 *   2. Scroll-reveal for .rgv-reveal elements
 */
(function () {
  'use strict';

  function initComparison(root) {
    var frame = root.querySelector('.rgv-ba__frame');
    if (!frame || frame.dataset.rgvBound) return;
    frame.dataset.rgvBound = '1';

    function setPos(clientX) {
      var r = frame.getBoundingClientRect();
      var pct = Math.min(100, Math.max(0, ((clientX - r.left) / r.width) * 100));
      frame.style.setProperty('--rgv-ba-pos', pct + '%');
    }

    function onPointerDown(e) {
      e.preventDefault();
      setPos(e.clientX);
      function move(ev) { setPos(ev.clientX); }
      function up() {
        window.removeEventListener('pointermove', move);
        window.removeEventListener('pointerup', up);
      }
      window.addEventListener('pointermove', move);
      window.addEventListener('pointerup', up);
    }

    frame.addEventListener('pointerdown', onPointerDown);
    frame.addEventListener('keydown', function (e) {
      var cur = parseFloat(frame.style.getPropertyValue('--rgv-ba-pos')) || 50;
      if (e.key === 'ArrowLeft') { frame.style.setProperty('--rgv-ba-pos', Math.max(0, cur - 4) + '%'); }
      if (e.key === 'ArrowRight') { frame.style.setProperty('--rgv-ba-pos', Math.min(100, cur + 4) + '%'); }
    });
  }

  function initReveal() {
    var els = document.querySelectorAll('.rgv-reveal');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function init(scope) {
    (scope || document).querySelectorAll('.rgv-ba').forEach(initComparison);
    initReveal();
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', function () { init(); });

  // Re-bind after Shopify theme-editor section renders
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
